// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Tnkqz","title":"Info_title__rmVm0","links":"Info_links__Alcui","link":"Info_link__3-fxu","logo":"Info_logo__3pnUC"};